<template>
	<v-btn
		class="my-2"
		:loading="progress"
		:disabled="progress"
		color="success"
		v-bind="$attrs"
		x-large
		type="submit"
	>
		<slot>שמירה</slot>
		<template v-slot:loader>
			<span class="custom-loader">
				<v-icon light>cached</v-icon>
			</span>
    </template>
  </v-btn>
</template>

<script>
export default {
  name: "BtnLoader",
  props: {
    progress: {
      default: false,
    },
    icon: {
      default: "cached",
    },
  },
};
</script>

<style>

</style>
